


// import React, { useEffect, useState, useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Carousel } from 'react-bootstrap';
// import Rightcontainer from '../Components/Rightcontainer';
// import Downloadbutton from '../Components/Downloadbutton';
// import DownloadPopup from '../Components/DownloadPopup';
// import Header from '../Components/Header';
// import { LanguageContext } from '../Components/LanguageContext';
// import { Sparkles, MessageCircle, Gamepad2, Radio } from 'lucide-react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// // import './Landing.css';

// export default function Landing({ userAllData }) {
//   const [showDownloadPopup, setShowDownloadPopup] = useState(true);
//   const { language } = useContext(LanguageContext);

//   const siteSettingRaw = localStorage.getItem('sitSetting');
//   let siteSetting = {};
//   try {
//     siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
//   } catch (e) {
//     siteSetting = {};
//   }

//   const translations = {
//     hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
//     en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
//   };

//   const t = translations[language] || translations.en;

//   return (
//     <>
//       {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}

//       <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
//         {/* Ambient background light blurs */}
//         <div className="landing-ambient-glow glow-1"></div>
//         <div className="landing-ambient-glow glow-2"></div>

//         <div className="landing-main-container">

//           {/* ANNOUNCEMENT MESSAGE BANNER */}
//           {siteSetting?.site_message && (
//             <div className="announcement-card animate-fade-down">
//               <div className="announcement-content">
//                 <Sparkles className="sparkle-icon" size={18} />
//                 <span>{siteSetting.site_message}</span>
//               </div>
//             </div>
//           )}
//  <div className="landing_page_slider">
//                   <Carousel interval={2000} pause="hover" controls={false}
//                     indicators={false}>
//                     {" "}

//                     <Carousel.Item>
//                       <img
//                         className="d-block w-100"
//                         src="./images/slider1.png"
//                         alt="Second slide"
//                       />
//                     </Carousel.Item>
//                     <Carousel.Item>
//                       <img
//                         className="d-block w-100"
//                         src="./images/slider2.png"
//                         alt="First slide"
//                       />
//                     </Carousel.Item>
                   
//                   </Carousel>
//                 </div>
//           {/* GAMES SELECTION GRID */}
//           <section className="games-section-wrapper">
//             <div className="games-section-header">
//               <h3 className="section-title">
//                 <Gamepad2 size={22} className="title-icon" /> Featured Games
//               </h3>
//             </div>

//             <div className="games-grid-container">
//               {/* LUDO CLASSIC MANUAL CARD */}
//               <Link to="/Homepage/ludoClassicManual" className="game-card-link">
//                 <div className="game-card-box">
//                   <div className="live-status-pill">
//                     <Radio size={12} className="pulse-radio" />
//                     <span>LIVE</span>
//                   </div>
//                   <div className="game-card-img-wrap">
//                     <img
//                       src="./mainimage/ludoclassic.png"
//                       alt="Ludo Classic"
//                       className="game-cover-img"
//                     />
//                   </div>
//                   <div className="card-hover-overlay">
//                     <span className="play-btn-pill">{t.playNow}</span>
//                   </div>
//                 </div>
//               </Link>

//               {/* LUDO WHATSAPP SUPPORT CARD */}
//               {siteSetting?.whatsappSupport && (
//                 <a
//                   href={siteSetting?.whatsappSupport}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="game-card-link"
//                 >
//                   <div className="game-card-box support-card-variant">
//                     <div className="live-status-pill red-live">
//                       <Radio size={12} className="pulse-radio" />
//                       <span>LIVE</span>
//                     </div>
//                     <div className="game-card-img-wrap">
//                       <img
//                         src="./mainimage/ludosupport.png"
//                         alt="Ludo Support"
//                         className="game-cover-img"
//                       />
//                     </div>
//                     <div className="card-hover-overlay">
//                       <span className="play-btn-pill gold">{t.support}</span>
//                     </div>
//                   </div>
//                 </a>
//               )}
//             </div>
//           </section>

//           {/* DOWNLOAD APP BUTTON SECTION */}
//           <div className="download-button-wrapper">
//             <Downloadbutton />
//           </div>

//         </div>
//       </div>

//       {/* WHATSAPP SUPPORT FLOATING ACTION */}
//       {siteSetting?.whatsappSupport && (
//         <div className="floating-social-btn whatsapp-floating">
//           <a href={siteSetting.whatsappSupport} target="_blank" rel="noreferrer">
//             {/* Can optionally display floating whatsapp icon here */}
//           </a>
//         </div>
//       )}

//       {/* WHATSAPP CHANNEL JOIN BUTTON */}
//       {/* <a
//         href="https://whatsapp.com/channel/0029Vb8PwCwHrDZnj7lWU62q"
//         target="_blank"
//         rel="noreferrer"
//         className="join-channel-btn pulse-glow-btn"
//       >
//         <MessageCircle size={18} />
//         <span>🎁 Join Channel</span>
//       </a> */}

//       {/* RIGHT SIDEBAR ON DESKTOP */}
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// }



import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Rightcontainer from '../Components/Rightcontainer';
import Downloadbutton from '../Components/Downloadbutton';
import Header from '../Components/Header';
import { LanguageContext } from '../Components/LanguageContext';
import {
  Star,
  Gamepad2,
  Radio,
  Users,
  ChevronRight,
} from 'lucide-react';

// import './Landing.css';

export default function Landing({ userAllData }) {
  const { language } = useContext(LanguageContext);
  const [siteSetting, setSiteSetting] = useState({});

  useEffect(() => {
    try {
      const raw = localStorage.getItem('sitSetting');

      if (raw && raw !== 'undefined') {
        setSiteSetting(JSON.parse(raw) || {});
      }
    } catch (error) {
      console.error('Unable to load site settings:', error);
    }
  }, []);

  const translations = {
    hi: {
      welcome: 'स्वागत है, खेलें और आनंद लें',
      games: 'गेम्स',
      chooseMode: 'अपना गेम चुनें',
      live: 'LIVE',
      playNow: 'अभी खेलें',
      support: 'सपोर्ट',
      refer: 'रेफर करें और कमाएं',
      commission: '1% कमीशन',
      invite: 'दोस्तों को आमंत्रित करें और कमाएं',
      featured: 'FEATURED GAMES',
    },
    en: {
      welcome: 'Welcome, Play and Enjoy',
      games: 'GAMES',
      chooseMode: 'Choose a mode',
      live: 'LIVE',
      playNow: 'Play Now',
      support: 'Support',
      refer: 'REFER & EARN',
      commission: '1% COMMISSION',
      invite: 'Invite friends and earn',
      featured: 'FEATURED GAMES',
    },
  };

  const t = translations[language] || translations.en;

  return (
    <>
      <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
        <div className="mk-landing-glow mk-glow-one" />
        <div className="mk-landing-glow mk-glow-two" />

        <main className="mk-landing-main">
          {/* Welcome banner */}
          <div className="mk-welcome-banner">
            <div className="mk-welcome-dots" />

            <div className="mk-welcome-content">
              <Star
                size={25}
                className="mk-welcome-star"
                fill="currentColor"
              />

              <span className="mk-welcome-text">
                {siteSetting?.site_message || t.welcome}
              </span>
            </div>

            <div className="mk-welcome-arrow" />
          </div>

          {/* Games heading */}
          <section className="mk-games-section">
            <div className="mk-games-heading">
              <div className="mk-heading-icon">
                <Gamepad2 size={23} />
              </div>

              <div className="mk-heading-copy">
                <h2>{t.games}</h2>
                <p>{t.chooseMode}</p>
              </div>
            </div>

            <div className="mk-games-grid">
              {/* Ludo Classic */}
              <Link
                to="/Homepage/ludoClassicManual"
                className="mk-game-card mk-classic-card"
              >
                <div className="mk-game-art">
                  <span className="mk-live-badge">
                    <span className="mk-live-dot" />
                    <Radio size={12} />
                    {t.live}
                  </span>

                  <img
                    src="./mainimage/ludoclassic.png"
                    alt="Ludo Classic"
                    className="mk-game-image"
                  />

                  <div className="mk-game-hover">
                    <span className="mk-play-pill">{t.playNow}</span>
                  </div>
                </div>

                <div className="mk-game-footer">
                  <span>LUDO CLASSIC</span>
                </div>
              </Link>

              {/* Existing WhatsApp support */}
              {siteSetting?.whatsappSupport && (
                <a
                  href={siteSetting.whatsappSupport}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mk-game-card mk-support-card"
                >
                  <div className="mk-game-art">
                    <span className="mk-coming-badge">
                      {t.support}
                    </span>

                    <img
                      src="./mainimage/ludosupport.png"
                      alt="WhatsApp Support"
                      className="mk-game-image"
                    />

                    <div className="mk-game-hover">
                      <span className="mk-play-pill">
                        {t.support}
                      </span>
                    </div>
                  </div>

                  <div className="mk-game-footer">
                    <span>{t.support.toUpperCase()}</span>
                  </div>
                </a>
              )}
            </div>
          </section>

          {/* Refer & Earn banner */}
          <div className="mk-refer-banner">
            <div className="mk-refer-icon">
              <Users size={22} />
            </div>

            <div className="mk-refer-content">
              <span className="mk-refer-label">{t.refer}</span>
              <h3>{t.commission}</h3>
              <p>{t.invite}</p>
            </div>

            <div className="mk-refer-arrow">
              <ChevronRight size={22} />
            </div>
          </div>

          {/* Existing download feature */}
          <div className="mk-download-section">
            <Downloadbutton />
          </div>
        </main>
      </div>

      {/* Desktop sidebar */}
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
